import { Injectable, Inject } from "@angular/core"
import { DOCUMENT } from '@angular/common'
import { request } from 'request'
import { errorToast } from "src/toaster"

@Injectable({providedIn: 'root'})
export class HubspotService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  connectToHubspot = ({customerId, redirectPage}: { customerId: number, redirectPage: string }) => {
    const url = `/customers/${customerId}/hubspot_credentials.json`
    request.post(url, {redirect_page: redirectPage}, { headers: { 'Access-Control-Allow-Origin': '*' }}).then(response => {
      const hubspotUrl = response.url
      this.document.location.href = hubspotUrl
    }).catch(e => {
      errorToast(e)
    })
  }
}


